import { Props } from "@storeblocks/alert";
import { UserInputObstacle } from "Store/eventFailed/errorDisplayedInterface";
import { alertError } from "Store/eventFailed/errorDisplayedSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AlertType } from ".";

export interface AlertReportInfo extends Pick<Props, "title" | "description"> {
  alertId?: string;
  alertType?: AlertType;
  noReporting?: boolean;
}

export const useAlertReport = ({
  alertType,
  alertId,
  noReporting,
  description,
  title,
}: AlertReportInfo): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (alertType !== undefined && !noReporting) {
      const fieldInfo = {
        ...(alertId && { fieldId: alertId }),
        alertType,
        additionalInfo: [...(description ? [description] : [])],
      };
      dispatch(
        alertError({
          errorType: UserInputObstacle.ALERT_OBSTACLE,
          errorText: title || alertId,
          fieldInfo,
        }),
      );
    }
  }, []);
};
